import { SortDirection } from './sort-direction.enum';
import { FilterModel } from '../../models/filter.model';
import { FundSort } from '../../../../data-access/enums/fund-sort';

export const sortMap: { [key in FundSort]: FilterModel<FundSort> } = {
  [FundSort.MostProfit]: {
    Column: FundSort.MostProfit,
    SortDirection: SortDirection.Descending,
  },
  [FundSort.LeastPrice]: {
    Column: FundSort.LeastPrice,
    SortDirection: SortDirection.Ascending,
  },
  [FundSort.LeastRisk]: {
    Column: FundSort.LeastRisk,
    SortDirection: SortDirection.Ascending,
  },
  [FundSort.Default]: {
    Column: FundSort.Default,
    SortDirection: SortDirection.Ascending,
  },
};
